import {Component, OnInit, TemplateRef} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ConfirmationDialogService, LeModalService, RouterHelpers} from "common-shared";
import {ManufacturingGraphModalComponent} from "../../graph/manufacturing-graph-modal/manufacturing-graph-modal.component";
import {ResourceModel} from "../models/resource.model";
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ResourcesQuery} from "../resource.store";
import {ResourceService} from "../resource.service";

@Component({
  selector: 'mes-resource-edit-menu-buttons',
  templateUrl: './resource-edit-menu-buttons.component.html',
})
export class ResourceEditMenuButtonsComponent implements OnInit {
  resource: ResourceModel;
  askCopyCodeNameModal: NgbModalRef;
  copyNewCode: string;
  copyNewName: string;
  constructor(private route: ActivatedRoute, protected modalService: LeModalService, private resourcesQuery: ResourcesQuery, private confirmationDialogService: ConfirmationDialogService, private resourceService: ResourceService, private router: Router) { }

  ngOnInit() {
    this.resource = this.route.snapshot.data.entity as ResourceModel;
  }

  showGraph() {
    this.modalService.show(ManufacturingGraphModalComponent, {initialState: {title: this.resource.DisplayName, id: this.resource.Id, graphSource: 'Resource'} as ManufacturingGraphModalComponent, class: 'modal-full'});
  }

  showCopyModal(template: TemplateRef<any>) {
    this.askCopyCodeNameModal = this.modalService.open(template);
  }

  copy() {
    const existing = this.resourcesQuery.getAll().find(value2 => value2.Code === this.copyNewCode);
    if (existing != null) {
      this.confirmationDialogService.confirm('Eksisteerib resource: ' + existing.DisplayName, 'Kirjutada üle?').then(value2 => {
        if (value2) {
          this.copyOrUpdate(existing.Id);
        }
      })
    } else {
      this.copyOrUpdate();
    }
  }

  copyOrUpdate(replaceId: string = null) {
    this.resourceService.copy(this.resource.Id, this.copyNewCode, this.copyNewName, replaceId).subscribe(value1 => {
      this.askCopyCodeNameModal.close();
      this.copyNewCode = this.copyNewName = null;
      RouterHelpers.navigate(this.router, ['./manufacturing/resource/edit', value1]);
    });
  }
}
